import { MdTimer } from "react-icons/md";

export default function AllRankings() {
  return (
    <div className="flex flex-col justify-center items-center mt-8">
      <div className="">
        <MdTimer size={30} color="#939496" />
      </div>
      <span className=" font-bold mt-4">Rankings Dashboard</span>
      <div className="text-gray-600">
        <span className="text-xs">Work in progress</span>
      </div>
    </div>
  );
}
